// Last-known list data per tab + line, so a tab can paint instantly on
// revisit and refresh quietly behind it (no "empty" flash while loading).
// In-memory first; mirrored to localStorage so a cold launch also has
// something to show. Every storage touch is wrapped: it may be blocked.
const PREFIX = 'truva.listcache.v1.';
const MAX_BYTES = 300000;
const mem = new Map();

const keyOf = (kind, line) => `${PREFIX}${kind}.${line || ''}`;

export function getCached(kind, line) {
  const k = keyOf(kind, line);
  if (mem.has(k)) return mem.get(k);
  try {
    const raw = window.localStorage.getItem(k);
    if (raw) {
      const data = JSON.parse(raw);
      if (Array.isArray(data)) {
        mem.set(k, data);
        return data;
      }
    }
  } catch (_) { /* storage unavailable */ }
  return null;
}

export function setCached(kind, line, data) {
  if (!Array.isArray(data)) return;
  const k = keyOf(kind, line);
  mem.set(k, data);
  try {
    const raw = JSON.stringify(data);
    if (raw.length <= MAX_BYTES) window.localStorage.setItem(k, raw);
  } catch (_) { /* storage unavailable or full */ }
}

export function clearListCache() {
  mem.clear();
  try {
    const drop = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(PREFIX)) drop.push(k);
    }
    drop.forEach((k) => window.localStorage.removeItem(k));
  } catch (_) { /* ignore */ }
}
